module.exports = __webpack_public_path__ + "static/img/bg-caipanyuan.7f75931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cha/bg-caipanyuan.png
// module id = 917
// module chunks = 0